import React from 'react';

import './styles.scss';

// import Sidebar from './../../components/Sidebar';

export default function Home() {
  return (
    <>
      <div>
        <h1>Home Page</h1>
      </div>
    </>
  );
}
